declare const process: { env?: Record<string, string | undefined> };

export const firebaseConfig = {
  apiKey: process.env?.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env?.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env?.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env?.EXPO_PUBLIC_FIREBASE_APP_ID,
  messagingSenderId: process.env?.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  storageBucket: process.env?.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  measurementId: process.env?.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export function hasFirebaseConfig() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId && firebaseConfig.appId);
}
